
    // Enter in a one-line field leaves it (on a phone the key is «Done»):
    // the pending change goes to the server and the form is not submitted
    // natively, which would reload the page.
    export default {
      mounted() {
        this.el.addEventListener("keydown", (e) => {
          if (e.key === "Enter" && e.target.tagName === "INPUT") {
            e.preventDefault()
            e.target.blur()
          }
        })
      }
    }
  